<template>
  <div>
    <l-tooltip :class="$style.question">
      В тренажере использован фрагмент песни Billie Eilish - Bad Guy. Фрагмент дан в информационных целях в соответствии с ст. <span :class="$style.nowrap">1274 ГК РФ</span>
    </l-tooltip>
    <l-bg />
    <l-stripes-horizontal :count="42" hideLines>
      <div :class="$style.container">
        <div>
          <transition name="fade">
            <div :class="$style.player" v-if="stage === 2">
              <l-player @progress="(p) => { progress[0] = p }" url="audio/511/51516485_8000hz.wav" title="Частота дискретизации 8 kHz" />
            </div>
          </transition>
          <l-progress :left="progress[0]" v-if="stage === 2" />
          <div :class="$style.cols">
            <l-col
              v-for="(col, index) in notIdeal"
              :key="index"
              disabled
              v-model="col.value"
            />
          </div>
          <transition name="fade">
            <div :class="$style.button" v-if="stage === 2">
              <l-button @click="runHint" rounded>Выбрать</l-button>
            </div>
          </transition>
        </div>
        <div>
          <transition name="fade">
            <div :class="$style.player" v-if="stage === 2">
              <l-player @progress="(p) => { progress[1] = p }" url="audio/511/51516485.wav" title="Частота дискретизации 44.1 kHz" />
            </div>
          </transition>
          <l-progress :left="progress[1]" v-if="stage === 2" />
          <div :class="$style.cols">
            <l-col
              v-for="(col, index) in ideal"
              :key="index"
              disabled
              v-model="col.value"
            />
          </div>
          <transition name="fade">
            <div :class="$style.button" v-if="stage === 2">
              <l-button @click="nextStage" rounded>Выбрать</l-button>
            </div>
          </transition>
        </div>
      </div>
    </l-stripes-horizontal>
    <l-popupMessage
      :items="messages"
      :task="task"
      @click="nextStage"
    />
  </div>
</template>
<script>
import { reactive, ref } from '@vue/composition-api'

import { pushPopup, pushHint } from '@/utils/pushPopup'

import { ideal, notIdeal } from './data'
import {
 arr1, arr2, hint, task,
} from './arrs'

export default {
  name: 'step2',
  setup(props, { emit }) {
    const stage = ref(0)
    const messages = ref([])
    const progress = reactive({ 0: 0, 1: 0 })

    const nextStage = () => {
      messages.value = []

      if (stage.value === 0) {
        pushPopup(arr1, messages.value)
      }

      if (stage.value === 2) {
        pushPopup(arr2, messages.value)
      }

      if (stage.value === 3) {
        emit('nextStep', 3)
      }

      stage.value += 1
    }

    nextStage()

    const runHint = () => {
      pushHint(hint, messages.value)
    }

    return {
      stage,
      messages,
      progress,
      task,

      ideal,
      notIdeal,

      nextStage,
      runHint,
    }
  },
}
</script>
<style lang="scss" module>
.container {
  display: flex;
  width: 100%;
  padding-left: 11rem;
  padding-right: 6.5rem;
  height: 100%;

  & > div {
    width: 50%;
    position: relative;

    & + * {
      margin-left: 4rem;
    }
  }
}

.cols {
  position: relative;
  display: flex;
  align-items: flex-end;
  pointer-events: none;
  height: 100%;
}

.button {
  position: absolute;
  z-index: 5;
  left: 50%;
  bottom: 5rem;
  transform: translateX(-50%);
}

.player {
  position: absolute;
  top: 3.5rem;
  left: 0;
}
.question {
  position: absolute;
  right: 3rem;
  top: 3rem;
}

.nowrap {
  white-space: nowrap;
}
</style>
